import { http } from '@/core/api/';

const apiUrl = 'api/certificationore';

export const validateCertificationExistence = async (params) =>
  await http.get(`${apiUrl}/validatecertificationexistence`, {
    params,
  });

export const createOreCertification = async (payload) =>
  await http.post(`${apiUrl}/save`, payload);

export const searchOreCertifications = async (params) =>
  await http.get(`${apiUrl}/search`, { params });

export const uploadCertification = async (payload) =>
  await http.post(`${apiUrl}/upload`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const validateIsCertificationApprovable = async (certificationId) =>
  await http.get(`${apiUrl}/validateisapprovable/${certificationId}`);

export const switchCertificationStatus = async (payload) =>
  await http.put(`${apiUrl}/switchstatus`, payload);

export const setNotSubmitted = async (payload) =>
  await http.post(`${apiUrl}/setnotsubmitted`, payload);

export const getCertificationStatusHistory = async (params) =>
  await http.get(`${apiUrl}/statushistory`, { params });

export const getCentersWithoutCertification = async (params) => {
  return await http.get(`${apiUrl}/centers-whitout-certification`, {
    params,
  });
};
